module.exports = __webpack_public_path__ + "static/media/SecurityVerifiedIcon.90d53376.svg";